import React, { useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { FiMail, FiEye, FiEyeOff } from "react-icons/fi";
import login from "../../assets/css/login.css";
import { Link } from "react-router-dom";
const Login = () => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="main-wrapper">
      <Container fluid>
        <Row className="vh-100">
          {/* LEFT SIDE */}
          <Col lg={5} className="login-left d-none d-lg-flex">
            <div className="bg-overlay-img">
              <img src="/assets/img/bg/bg-01.png" className="bg-1" alt="" />
              <img src="/assets/img/bg/bg-02.png" className="bg-2" alt="" />
              <img src="/assets/img/bg/bg-03.png" className="bg-3" alt="" />
            </div>

            <div className="overlay-card">
              <h1>
                Empowering people <br />
                through seamless HR <br />
                management.
              </h1>

              <div className="team-img-wrapper">
                <img src="/assets/img/bg/authentication-bg-01.png" alt="" />
              </div>

              <p>
                Efficiently manage your workforce, streamline <br />
                operations effortlessly.
              </p>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col lg={7} md={12} className="login-right">
            <div className="login-form-wrapper">
              {/* LOGO */}
              <div className="text-center mb-4">
                <img src="/assets/img/logo-1.svg" alt="logo" height="40" />
              </div>

              <h2 className="text-center">Sign In</h2>
              <p className="text-center text-muted mb-4">
                Please enter your details to sign in
              </p>

              {/* EMAIL */}
              <Form.Group className="mb-3">
                <Form.Label>Email Address</Form.Label>
                <InputGroup>
                  <Form.Control type="email" />
                  <InputGroup.Text>
                    <FiMail />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {/* PASSWORD */}
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <div className="password-box">
                  <Form.Control type={showPassword ? "text" : "password"} />
                  <span onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </span>
                </div>
              </Form.Group>

              {/* OPTIONS */}
              <div className="d-flex justify-content-between mb-3">
                <Form.Check label="Remember Me" />
                <a href="#" className="text-danger">
                  Forgot Password?
                </a>
              </div>

              {/* BUTTON */}

              <Link to="/" className="text-decoration-none ">
                <Button className="w-100 login-btn">Sign In</Button>
              </Link>
              {/* REGISTER */}
              <div className="text-center mt-3">
                Don’t have an account?{" "}
                <a href="#" className="text-primary">
                  Create Account
                </a>
              </div>

              {/* OR */}
              <div className="divider">Or</div>

              {/* SOCIAL */}
              <div className="d-flex gap-2">
                <Button className="social-btn fb w-100">
                  <img src="/assets/img/icons/facebook-logo.svg" alt="" />
                </Button>

                <Button className="social-btn google w-100">
                  <img src="/assets/img/icons/google-logo.svg" alt="" />
                </Button>

                <Button className="social-btn apple w-100">
                  <img src="/assets/img/icons/apple-logo.svg" alt="" />
                </Button>
              </div>

              {/* FOOTER */}
              <p className="text-center mt-4 text-muted">
                Copyright © 2026 - Spectronx
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
